import React, { useState, useRef } from "react";
import { Context } from "../../context";
import { navigate } from "gatsby";
const SearchForm = () => {
    const context = React.useContext(Context);
    const [isInputShown, showInput] = useState(false);
    const form = useRef(null);
    const input = useRef(null);
    const submit = () => {
        if (!input.current.value.trim().length) {
            //empty search
            return;
        }
        navigate("/" + context.searchSlug, {
            state: {
                query: input.current.value.trim(),
            },
        });
    };
    return (React.createElement("form", { ref: form, onBlur: (e) => {
            if (!form || !form.current) {
                return;
            }
            if (!form.current.contains(e.relatedTarget) && isInputShown) {
                showInput(false);
            }
        }, className: "search " + (isInputShown ? "expanded" : "collapsed") },
        React.createElement("input", { ref: input, type: "search", placeholder: "Rechercher", onKeyUp: (e) => {
                if (e.keyCode === 13) {
                    submit();
                }
            } }),
        React.createElement("button", { onClick: (e) => {
                e.preventDefault();
                showInput(true);
            } },
            React.createElement("span", { className: "sr-only" }, "Afficher le champ de recherche")),
        React.createElement("button", { onClick: (e) => {
                e.preventDefault();
                submit();
            } },
            React.createElement("span", { className: "sr-only" }, "Rechercher"))));
};
export default SearchForm;
